import React from 'react';
import FlappyBird from './FlappyBird';

function App() {
  return <FlappyBird />;
}

export default App;
